import React from 'react';
import styles from './GenericInlineError.scss';

interface Props {
  errorDetails: React.ReactElement;
}

const GenericInlineError: React.FC<Props> = props => {
  return (
    <div className={styles.errorContainer}>
      <div className={`qm-icon-low-priority ${styles.errorIcon}`} />
      <p className={styles.errorText}>{props.errorDetails}</p>
    </div>
  );
};

export default GenericInlineError;
